import React, { useMemo, useState, useEffect } from "react";

import DataTable from "react-data-table-component";
import FilterComponent from "./FilterComponent";
import axios from 'axios'
import { API_BASE_PATH, REPORT_BASE_PATH } from "../Api";
import { EyeFill, FileArrowDown } from "react-bootstrap-icons";

const JobsTable = props => {
    const columns = [
        {
            name: "Id",
            selector: (row) => row.id,
            sortable: true,
            
        },
        {
            name: "JobName",
            selector: (row) => row.jobName,
            sortable: true,
            hide: "md"
        },
        {
            name: "JobType",
            selector: (row) => row.jobType,
            sortable: true,
            hide: "md",
            cell: row =>
                (
                <span>{row.validationFile && <a href={REPORT_BASE_PATH+"/"+row.validationFile}><FileArrowDown></FileArrowDown></a>}{row.jobType}</span>
                ) 
        },
        {
            name: "status",
            selector: (row) => row.status,
            sortable: true,
            hide: "md"
        },
        {
            name: "StartTime",
            selector: (row) => row.startTime,
            sortable: true,
            hide: "md",
            cell: row =>
                (
                <span>{new Date(+row.startTime).toString()}</span>
                ) 
        },
        {
            name: "Duration(Seconds)",
            selector: (row) => row.duration,
            sortable: true,
            hide: "md",
            cell: row =>
                (
                <span>{row.duration/1000}</span>
                ) 
        },
    ];
    const [data, setData] = useState([]);
    const [filterText, setFilterText] = React.useState("");
    const [resetPaginationToggle, setResetPaginationToggle] = React.useState(
        false
    );
    const filteredItems = data;
    const [loading, setLoading] = useState(false);
    const [totalRows, setTotalRows] = useState(0);
    const [perPage, setPerPage] = useState(10);
    var userInfo = localStorage.getItem("userInfo");
    if (userInfo) {
        userInfo = JSON.parse(userInfo);
    }
    
    const onDataFilter=val=>{
        setFilterText(val);
        fetchUsers(1,val);
    }

    const subHeaderComponent = useMemo(() => {
        const handleClear = () => {
            if (filterText) {
                setResetPaginationToggle(!resetPaginationToggle);
                onDataFilter("");
            }
        };

        return (
            <FilterComponent
                onFilter={e => onDataFilter(e.target.value)}
                onClear={handleClear}
                filterText={filterText}
                placeholder="Filter by Job Name"
            />
        );
    }, [filterText, resetPaginationToggle]);

    const fetchData=async page =>{
        const response = await axios.get(API_BASE_PATH+`/objects/jobs?lob=${userInfo.accountId}&page=${page}&count=${perPage}&resolve=true&orderby=date desc`);
        setData(response.data);
        let count = totalRows;
        if (count == 0) {
            const tr = await axios.get(API_BASE_PATH+`/objects/jobs/count?lob=${userInfo.accountId}&page=${page}&count=${perPage}&resolve=true&orderby=date desc`);
            count = tr.data.count;
        }
        // const c=total>0?total:perPage*page+response.data.length;
        setTotalRows(count);
        return response.data;
    }

    const fetchDataOC=async (page,filter) =>{
        const response = await axios.get(API_BASE_PATH+`/objects/jobs/jobName/${filter}?lob=${userInfo.accountId}&page=${page}&count=${perPage}&resolve=true&orderby=date desc`);
        setData(response.data);
        let count = response.data.length;
        
        setTotalRows(count);
        return response.data;
    }

    const fetchUsers = async (page,filt) => {
        setLoading(true);
        if(!filt){
            await fetchData(page);
        }else{
            await fetchDataOC(page,filt);
        }
        setPerPage(perPage);
        setLoading(false);
    };

    const handlePageChange = page => {
        fetchUsers(page);
    };

    const handlePerRowsChange = async (newPerPage, page) => {
        // setLoading(true);
        // const response = await axios.get(`/objects/outletClusters?lob=${userInfo.accountId}&page=${page}&count=${newPerPage}&resolve=true`);
        // setData(response.data.data);
        // setTotalRows(response.data.length+100);
        // //setPerPage(newPerPage);
        // setLoading(false);
    };

    useEffect(() => {
        // alert("Calling")

        fetchUsers(1); // fetch page 1 of users
    }, []);

    return (
        <DataTable
            title=""
            columns={columns}
            data={filteredItems}
            progressPending={loading}
            pagination
            paginationServer
            paginationPerPage={100}
            paginationTotalRows={totalRows}
            onChangeRowsPerPage={handlePerRowsChange}
            onChangePage={handlePageChange}
            subHeader
            subHeaderComponent={subHeaderComponent}
        />
    );
};




export default JobsTable;
